import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { StyledSelectGroup } from "../../filter/styledFiter";
import FormControl from "@material-ui/core/FormControl";
import { useTranslation } from "react-i18next";

const PaymentSystemSelect = ({
  checkedPaymentSystem,
  setCheckedPaymentSystem,
  mappedData,
  checkedService
}) => {
  const { t } = useTranslation("otherInterface");

  const optionsSource = checkedService
    ? mappedData?.services[checkedService]?.paymentSystems
    : mappedData?.allPaymentSystems;

  return (
    <StyledSelectGroup>
      <FormControl>
        <Autocomplete
          options={optionsSource || []}
          value={checkedPaymentSystem || null}
          onChange={(event, paymentSystem) => setCheckedPaymentSystem(paymentSystem)}
          renderInput={(params) => (
            <TextField {...params} label={t("serviceReletionships.paymentSystem")} />
          )}
          blurOnSelect
        />
      </FormControl>
    </StyledSelectGroup>
  );
};

export default PaymentSystemSelect;